import React, {
  memo,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from 'react'

import { Icon, Search, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'
import { debounce } from 'throttle-debounce'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import UploadThreeDModelButton from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/UploadThreeDModelButton'

import Filtering from './Components/Filtering/Filtering'

const icon = <Icon notSpaced svgComponent={Search} color="dark" size="small" />

const SEARCH_DEBOUNCE_MS = 500

function SearchInput({ withFiltering, onSearch }) {
  const t = useTranslation()
  const [search, setSearch] = useState('')

  const debouncedSearch = useMemo(
    () => debounce(SEARCH_DEBOUNCE_MS, value => onSearch((value ?? '').trim())),
    [onSearch],
  )

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch])

  const handleChange = useCallback((e) => {
    const nextValue = e.target.value
    setSearch(nextValue)
    debouncedSearch(nextValue)
  }, [debouncedSearch])

  const handleKeyDown = useCallback((e) => {
    if (e.key !== 'Enter') {
      return
    }
    debouncedSearch.cancel()
    onSearch((e?.target?.value ?? '').trim())
  }, [debouncedSearch, onSearch])

  return (
    <div className="library-search">
      <TextInput
        id="search-input"
        placeholder={t('sidebar.search.placeholder')}
        value={search}
        size="small"
        textInputClassName="library-search__input"
        wrapperClassName="library-search__form"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        leadIcon={icon}
        isPilot
      />
      <UploadThreeDModelButton className="library-search__upload-button" />
      {withFiltering && <Filtering />}
    </div>
  )
}

SearchInput.propTypes = {
  withFiltering: bool,
  onSearch: func,
}

export default memo(SearchInput)
